// MenuConfigs.js

import { AppRoles, IS_PROD } from '@config/config'; // 👈 Import IS_PROD from your config
import { lazy } from 'react';

// Shared menu configuration
export const SHARED_MENU_CONFIG = {
  logout: {
    text: 'Logout',
    icon: 'sign-out',
    path: '/logout',
    requireAuth: true,
  },
};

// Menu configurations for public routes
export const PUBLIC_MENU_CONFIG = {
  index: {
    text: 'Map Viewer',
    icon: 'home',
    path: '/',
    requireAuth: false,
  },
  mapviewer: {
    text: 'Data Viewer',
    icon: 'apps',
    path: '/dataviewer',
    prefetch: () => import('@public/PgPubDataViewer.jsx'),
    requireAuth: false, //make it unvisible, and still can see http://localhost:8181/reservations
  },
  // login: {
  //   text: 'Login',
  //   icon: 'sign-in',
  //   path: '/login',
  //   prefetch: () => import('@public/PgPubLogin.jsx'),
  //   requireAuth: false,
  //   hideWhenAuth: true,
  // },
  // register: {
  //   text: 'register',
  //   icon: 'sign-in',
  //   path: '/register',
  //   prefetch: () => import('@public/PgPubRegister.jsx'),
  //   requireAuth: false,
  //   hideWhenAuth: true,
  // },
  resources: {
    text: 'Resources',
    icon: 'information',
    path: '/resources',
    prefetch: () => import('@public/tests/PgPubResource.jsx'),
    hasMapTaskBar: true,
    requireAuth: false,
   
  },
 
  test: {
    text: 'Test',
    icon: 'apps',
    path: '/test',
    requireAuth: false,
    hideOnProd: IS_PROD, // 👈 Hides this item if IS_PROD evaluates to true

  },
  forbidden: {
    path: '/forbidden',
    prefetch: () => import('@cores/security/Forbidden.jsx'),
  },
  ...SHARED_MENU_CONFIG,
};

// Menu configurations for app routes
export const APP_MENU_CONFIG = {
  index: {
    text: 'Home',
    icon: 'map',
    path: '/app',
    requireAuth: true,
    hasMapTaskBar: true,
    dropdownItems: [
      { text: 'Open Map', icon: 'folder-open', action: 'open-map' },
      { text: 'Save Map', icon: 'save', action: 'save-map' },
      { text: 'Save Map As', icon: 'save-as', action: 'save-map-as' },
      { text: 'Load Default Map', icon: 'add-in-new', action: 'load-default-map' },
    ],
    taskItems: [
      { text: 'Open Map', icon: 'folder-open', action: 'open-map' },
      { text: 'Save Map', icon: 'save', action: 'save-map' },
      { text: 'Save Map As', icon: 'save-as', action: 'save-map-as' },
      { text: 'Load Default Map', icon: 'add-in-new', action: 'load-default-map' },
    ],
  },
  data: {
    text: 'Data',
    icon: 'data',
    path: '/app/data',
    prefetch: () => import('@apps/pages/PgAppData.jsx'),
    requireAuth: true,
    hasMapTaskBar: false,
    dropdownItems: [
      { text: 'Import Data', icon: 'import', action: 'import-data' },
      { text: 'Export Data', icon: 'export', action: 'export-data' },
    ],
    taskItems: [
      { text: 'Import Data', icon: 'import', action: 'import-data' },
      { text: 'Export Data', icon: 'export', action: 'export-data' },
    ],
  },
  admin: {
    text: 'Admin',
    icon: 'gear',
    path: '/app/admin',
    requireAuth: true,
    //requireRole: AppRoles.admin,
    prefetch: () => import('@apps/admin/PgAdminUser.jsx'),
  },
  ...SHARED_MENU_CONFIG,
};

// Menu configurations for test routes
export const TEST_MENU_CONFIG = {
  index: {
    text: 'Home',
    icon: 'home',
    path: '/test',
    hasMapTaskBar: true,
    requireAuth: false,
  },
  SPViewer: {
    text: 'Sp Viewer',
    icon: 'apps',
    path: '/test/spviewer',
    requireAuth: true, //make it unvisible, and still can see http://localhost:8181/reservations
  },
  app: {
    text: 'ReservationsApp',
    icon: 'apps',
    path: '/test/reservations',
    requireAuth: true, //make it unvisible, and still can see http://localhost:8181/reservations
  },
  map1: {
    text: 'P_ShellPanelSplit',
    icon: 'apps',
    path: '/test/map1',
    prefetch: () => import('@apps/components/mapViewers/tests/MapViewerWithShellPanelSplit.jsx'),
    requireAuth: false,
  },
  map2: {
    text: 'P_ShellPanelsLR',
    icon: 'question',
    path: '/test/map2',
    prefetch: () => import('@apps/components/mapViewers/tests/MapViewerWithShellPanelsLROverlay.jsx'),
    requireAuth: false,
  },
  map3: {
    text: 'P_LRPanels',
    icon: 'users',
    path: '/test/map3',
    requireAuth: false,
    prefetch: () => import('@apps/components/mapViewers/tests/MapViewerWithLRPanels.jsx'),
  },
  map4: {
    text: 'P_SearchPanel',
    icon: 'data',
    path: '/test/map4',
    requireAuth: false,
    prefetch: () => import('@apps/components/mapViewers/tests/MapViewerWithSearchPanel.jsx'),
  },
  data: {
    text: 'Pie Maps',
    icon: 'apps',
    path: '/test/piemap',
    requireAuth: false,
    prefetch: () => import('@public/tests/PgPubPieMap.jsx'),
  },
  weather: {
    text: 'Test Weather',
    icon: 'apps',
    path: '/test/weather',
    requireAuth: false,
    prefetch: () => import('@public/tests/PgPubTestWeather.jsx'),
  },
  settings: {
    text: 'Settings',
    icon: 'gear',
    path: '/test/settings',
    requireAuth: true,
    prefetch: () => import('@apps/admin/PgAdminUser.jsx'),
    dropdownItems: [
      { text: 'System Settings', icon: 'gear', action: 'system-settings' },
      { text: 'Security', icon: 'lock', action: 'security' },
      { text: 'Backup', icon: 'save', action: 'backup' },
      {
        text: 'Logs',
        icon: 'file-report',
        action: 'logs',
        dropdownItemTaskItems: [
          { text: 'System Logs', icon: 'gear', action: 'systemLogging' },
          { text: 'App Logs', icon: 'lock', action: 'appLogging' },
        ],
      },
    ],
    taskItems: [
      { text: 'System Settings', icon: 'gear', action: 'system-settings' },
      { text: 'Security', icon: 'lock', action: 'security' },
      { text: 'Backup', icon: 'save', action: 'backup' },
    ],
  },
  ...SHARED_MENU_CONFIG,
};

// Common task bar items
export const COMMON_TASK_BAR_ITEMS = [
  {
    id: 'zoom-in',
    icon: 'magnifying-glass-plus',
    tooltip: 'Zoom In',
  },
  {
    id: 'zoom-out',
    icon: 'magnifying-glass-minus',
    tooltip: 'Zoom Out',
  },
  {
    id: 'fixed-zoom-in',
    icon: 'zoom-in-fixed',
    tooltip: 'Fixed Zoom In',
  },
  {
    id: 'fixed-zoom-out',
    icon: 'zoom-out-fixed',
    tooltip: 'Fixed Zoom Out',
  },
  {
    id: 'identify',
    icon: 'information',
    tooltip: 'Identify',
  },
  {
    id: 'measure',
    icon: 'measure',
    tooltip: 'Measure',
  },
  {
    id: 'select',
    icon: 'select',
    tooltip: 'Select Feature',
  },
];